import { Component } from '@angular/core';
import { Toast, ToastrService } from '../../services/toastr.service';

const ICONS: Record<Toast['type'], string> = {
  success: 'bi-check-lg',
  error: 'bi-x-lg',
  warning: 'bi-exclamation-lg',
  info: 'bi-info-lg'
};

const TITLES: Record<Toast['type'], string> = {
  success: 'Success',
  error: 'Error',
  warning: 'Warning',
  info: 'Info'
};

@Component({
  selector: 'app-toastr',
  imports: [],
  templateUrl: './toastr.component.html',
  styleUrl: './toastr.component.scss'
})
export class ToastrComponent {

  constructor(public toastrService: ToastrService) { }

  iconFor(type: Toast['type']): string {
    return ICONS[type];
  }

  titleFor(type: Toast['type']): string {
    return TITLES[type];
  }
}
